import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Input} from 'reactstrap';

//SimpleBar
import SimpleBar from "simplebar-react";

//import images
import {useSelector} from "react-redux";
import {APIClient} from "../../helpers/api_helper";

const SearchOption = () => {
    const [value, setValue] = useState("");
    const [associates, setAssociates] = useState([]);
    const [menus, setMenus] = useState([]);
    const [dataMenus, setDataMenus] = useState([]);

    const api = new APIClient();

    const {itens, error} = useSelector((state) => ({
        itens: state.Menu.itens,
        error: state.Menu.error,
    }));

    const onChangeData = (valueInput) => {
        setValue(valueInput);
        onSearch(valueInput);
    };

    const formatData = () => {
        let data = [];

        itens.map((item) => {
                // eslint-disable-next-line no-prototype-builtins
                if (!item.hasOwnProperty('subItems')) {
                    data.push(item);
                } else {
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.map((subItem) => {
                                data.push(subItem);
                            }
                        );
                    }
                }
            }
        )
        setDataMenus(data);
    }

    const getAssociates = async (value) => {
        return await api.create("/register/customer-search", {
            "name": value,
            "limit_size": 5,
        });
    };

    const onSearch = async (value) => {
        if (value === "") {
            setAssociates([]);
            setMenus([]);
        } else {
            setMenus(dataMenus.filter(
                item => item.label.normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase()
                    .includes(
                        value
                            .toLowerCase()
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                    )
            ));
        }

        if (value === "") {
            setAssociates([]);
        } else {
            setAssociates(await getAssociates(value));
        }

    }

    useEffect(() => {
        formatData();
    }, [itens]);

    useEffect(() => {
        var searchOptions = document.getElementById("search-close-options");
        var dropdown = document.getElementById("search-dropdown");
        var searchInput = document.getElementById("search-options");

        searchInput.addEventListener("focus", function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                dropdown.classList.add("show");
                searchOptions.classList.remove("d-none");
            } else {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
                setValue("");
            }
        });

        searchInput.addEventListener("keyup", function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                dropdown.classList.add("show");
                searchOptions.classList.remove("d-none");
            } else {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
                setValue("");
            }
        });

        searchOptions.addEventListener("click", function () {
            searchInput.value = "";
            dropdown.classList.remove("show");
            searchOptions.classList.add("d-none");
            setValue("");
        });

        document.body.addEventListener("click", function (e) {
            if (e.target.getAttribute('id') !== "search-options") {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
                setValue("");
            }
        });
    }, []);

    return (
        <React.Fragment>
            <div className="app-search d-none d-md-block">
                <div className="position-relative">
                    <Input type="text" className="form-control" placeholder="Pesquisar..."
                           id="search-options"
                           value={value}
                           onChange={e => {
                               onChangeData(e.target.value);
                           }}/>
                    <span className="mdi mdi-magnify search-widget-icon"></span>
                    <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                          id="search-close-options"></span>
                </div>

                <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                    <SimpleBar style={{maxHeight: "320px"}}>

                        {/* <div className="dropdown-header">
                            <h6 className="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                        </div>

                            <div className="dropdown-item bg-transparent text-wrap">
                            <Link to="/" className="btn btn-soft-secondary btn-sm btn-rounded">how to setup <i
                            className="mdi mdi-magnify ms-1"></i></Link>
                            <Link to="/" className="btn btn-soft-secondary btn-sm btn-rounded">buttons <i
                            className="mdi mdi-magnify ms-1"></i></Link>
                            </div>
                        */}

                        <FeedbackEmpty isEmpty={associates.length === 0 && menus.length === 0}/>

                        <PagesList menuItems={menus}/>
                        <AssociatesList associates={associates}/>

                    </SimpleBar>
                </div>
            </div>
        </React.Fragment>
    );

}


const FeedbackEmpty = ({isEmpty}) => {

    return isEmpty && (
        <div className="dropdown-item bg-transparent text-wrap">
            <div className="text-muted text-center">
                <small>Nenhum resultado encontrado</small>
            </div>
        </div>
    );
}

const PagesList = ({menuItems}) => {
    return menuItems.length > 0 && (
        <>
            <div className="dropdown-header mt-2">
                <h6 className="text-overflow text-muted mb-1 text-uppercase">Páginas</h6>
            </div>

            {(menuItems || []).map((item, index) => {
                return (
                    <Link key={index} to={item.link} className="dropdown-item notify-item">
                        <i className={`${item.icon} align-middle fs-18 text-muted me-2`}></i>
                        <span>{item.label}</span>
                    </Link>
                )
            })}
        </>
    )
}

const AssociatesList = ({associates}) => {

    return associates.length > 0 && (
        <>
            <div className="dropdown-header mt-2">
                <h6 className="text-overflow text-muted mb-2 text-uppercase">Associados</h6>
            </div>

            <div className="notification-list">
                {
                    (associates || []).map((item, index) => {
                        return (
                            <Link key={index} to={`/associados/edit/${item.hashid}`}
                                  className="d-flex dropdown-item notify-item py-2">
                                <div className="flex-1">
                                    <h6 className="m-0">{item.name}</h6>
                                    <span className="fs-11 mb-0 text-muted">{item.email}</span>
                                </div>
                            </Link>

                        )
                    })
                }
            </div>
        </>
    )
}


export default SearchOption;